/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ShowProgress from '../ui/Backdrop';
import Theme from '../ui/Theme';
import {
  showProgress,
  getJourneyDetails,
  getLevelDetails,
  getSelectedLevelID,
} from '../../redux/actions/DealershipActions';
import 'react-toastify/dist/ReactToastify.css';
import service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';
toast.configure();

const useStyles = makeStyles((theme) => ({
  resize: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '27em',
    padding: '5px 10px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    marginTop: '9px',
  },
  cancelBtn: {
    width: '200px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  createBtn: {
    width: '200px',
    height: '42px',
    marginLeft: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  resize2: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '38em',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    maxHeight: '58vh',

    overflow: 'scroll',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
}));

const AddNewLevelMenu = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const levelID = useSelector((state) => state.getSelectedLevelID);
  const levelIds = useSelector((state) => state.JourneyDetails.journeydetails.levels);
  const levelDetails = useSelector((state) => state.getLevelDetails.leveldetails);

  const [viewLevelPop, setViewLevelPop] = useState(props.open);
  const [levelTitle, setLevelTitle] = useState('');
  const [levelGoal, setLevelGoal] = useState('');

  useEffect(() => {
    if (props.edit === true) {
      setLevelTitle(levelDetails.title);
      setLevelGoal(levelDetails.description);
    }
  }, []);

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!levelTitle) {
      formIsValid = false;
      errors.push('Please enter level title.');
    }
    if (!levelGoal) {
      formIsValid = false;
      errors.push('Please enter level goals.');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };
  const submit = async (edit) => {
    const check = validateForm();
    if (check) {
      let data = '';
      dispatch(showProgress(true));
      if (edit === false) {
        data = JSON.stringify({
          journeyId: journeyDetails.id,
          title: levelTitle,
          description: levelGoal,
          skillLevel: 'novice',
          tagIds: [],
        });
        await service
          .post(apiEndpoints.JOURNEY_LEVEL, data)
          .then((response) => {
            dispatch(getJourneyDetails('updateLevelIds', response));
            dispatch(getSelectedLevelID(journeyDetails.levels[0].id));
            if (levelIds[0].id === response.id) {
              dispatch(getLevelDetails('leveldetails', response));
            }
            closePopup();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            console.log(error);
            closePopup();
            dispatch(showProgress(false));
          });
      } else {
        data = JSON.stringify({
          title: levelTitle,
          description: levelGoal,
          skillLevel: 'novice',
          tagIds: [],
        });
        await service
          .put(apiEndpoints.JOURNEY_LEVEL_DETAILS.replace('LEVEL_ID', levelID), data)
          .then((response) => {
            dispatch(getLevelDetails('editLevelDetails', response));
            dispatch(getJourneyDetails('updateLevel', response));
            closePopup();
            dispatch(showProgress(false));
            notifySuccess('Levels Updated');
          })
          .catch((error) => {
            console.log(error);
            closePopup();
            dispatch(showProgress(false));
            ErrorToast(error);
          });
      }
    }
  };
  const handleLevelTitleChange = (e) => {
    setLevelTitle(e.target.value);
  };
  const handleLevelGoalChange = (e) => {
    setLevelGoal(e.target.value);
  };
  const closePopup = () => {
    setViewLevelPop(false);
    props.close();
  };

  return (
    <Modal
      isOpen={viewLevelPop}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '392px',
          width: '492px',

          overflow: 'auto',
        },
      }}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Grid item style={{ width: '80%' }}>
          <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              {props.edit === false ? 'Add Level' : 'Update Level'}
            </Grid>
            <Grid item className={classes.popupSubHeading}>
              In the journey: {journeyDetails.title}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
        </Grid>
      </Grid>
      <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
        <Grid item>
          <TextField
            id="levelTitleId"
            name="levelTitle"
            required
            autoFocus
            autoComplete="off"
            autoSave="off"
            onChange={handleLevelTitleChange}
            placeholder="Enter Level's title here"
            multiline
            InputProps={{
              disableUnderline: true,
              classes: {
                input: classes.resize,
              },
            }}
            value={levelTitle}
            rows={5}
          />
        </Grid>
        <Grid item>
          <div className={classes.popupLabels}>
            <label htmlFor="levelGoal">Goal of this level</label>
          </div>

          <TextField
            id="levelGoalId"
            name="levelGoal"
            required
            autoComplete="off"
            autoSave="off"
            onChange={handleLevelGoalChange}
            placeholder="Enter level goal here"
            multiline
            value={levelGoal}
            InputProps={{
              disableUnderline: true,
              classes: {
                input: classes.resize2,
              },
            }}
            rows={5}
          />
        </Grid>
        <Grid item>
          <Grid container direction="row" style={{ marginLeft: '8%' }}>
            <Grid item>
              <Button onClick={closePopup} variant="contained" disableElevation className={classes.cancelBtn}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.createBtn}
                onClick={() => submit(props.edit)}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ShowProgress />
    </Modal>
  );
};

export default AddNewLevelMenu;
